
import { Component, Prop } from "nuxt-property-decorator";
import LoadingSpinner from "~/components/molecules/display/LoadingSpinner.vue";
import PelletsChartTooltip from "~/components/molecules/display/pellets/PelletsChartTooltip.vue";
import PelletsChartBase, {
  PELLETS_CHART_COLORS,
  PelletsChartTheme,
} from "~/mixins/PelletsChartBase";

@Component({
  components: { LoadingSpinner, PelletsChartTooltip },
})
export default class PelletsChartComparison extends PelletsChartBase {
  @Prop({ default: false }) fullWidth: boolean;
  @Prop({ default: false }) isCityChart: boolean;

  get chartAspectRatio(): number {
    const width = this.viewportWidth;
    if (this.fullWidth) {
      if (width > 1100) return 3.2;
      return width < 700 ? 1.5 : 2.5;
    }
    if (width > 1100) return 2;
    return width < 700 ? 1.5 : 2.5;
  }

  get chartTheme(): PelletsChartTheme {
    return {
      ...PELLETS_CHART_COLORS,
      axis: {
        fontSize: this.fullWidth ? 16 : 13,
        color: "#7d7d7d",
      },
      yAxis: {
        beginAtZero: false,
        stepSize: 2,
        grace: "8%",
      },
      pointRadius: 3,
      xAxisMaxTicks: 3,
      legend: {
        display: true,
        pointStyleWidth: 30,
        fontSize: this.viewportWidth < 700 ? 12 : 16,
      },
      layout: {
        aspectRatio: this.chartAspectRatio,
        maintainAspectRatio: true,
      },
    };
  }
}
